/*
 * @Author: liqm
 * @Date: 2020-07-16
 * @Deccription: 请求处理
 */
import TYPES from '../types'

export const requestStatus = {
  requeststatus: '',
}
export const requestMutations = {
  [TYPES.SET_REQUEST_STATUS](state, data) {
    state.requeststatus = data
  },
}
